import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NdmsAuthService } from '../../shared/core-ndms/services/ndms-auth.service';
import { ApplicationItemViewModel } from './application-item.view-model';

@Injectable()
export class NdmsHomeService {
  private _applications$ = new BehaviorSubject(new Array<ApplicationItemViewModel>());
  get applications$() {
    return this._applications$.asObservable();
  };
  get applications() {
    return this._applications$.value;
  }

  initialApplicationsLoaded = false;

  constructor(
    private ndmsAuthService: NdmsAuthService) {
  }

  getAllApplications(): Promise<ApplicationItemViewModel[]> {
    return new Promise((resolve, reject) => this.ndmsAuthService.getAllApps().subscribe((appdata: any) => {
      let appItems: ApplicationItemViewModel[] = [];
      appdata.model.forEach(app => {
        let model = new ApplicationItemViewModel(
          app.key,
          app.appDescription,
          app.appGroup,
          app.appName,
          app.orderNumber,
          this.getUrl(app.url, app.isNewTab),
          false, //visible
          null,
          null,
          app.isNewTab,
          app.externalAuthenticationFields,
          app.externalAuthenticationRequired,
          app.isActive
        );
        appItems.push(model);
      });

      appItems = appItems.sort((a, b) => (a.orderNumber < b.orderNumber ? -1 : 1));

      this._applications$.next(appItems);

      return resolve(appItems);
    }, (error) => reject(error)));
  }

  setUserApplications(): Promise<ApplicationItemViewModel[]> {
    return new Promise((resolve, reject) => {
      this.ndmsAuthService.getUserApps().subscribe((user: any) => {
        let apps = user.userApplications || [];
        apps.forEach((app) => {
          let application = this.applications.find(i => i.appItemKey === app.appItemKey);
          application.accountStatusKey = app.accountStatus.key;
          application.accountStatusDescription = app.accountStatus.description;
          application.visible = true;
        });

        return resolve(this.applications.filter(i => i.visible) || []);
      }, (err) => reject(err));
    });
  }

  private getUrl(destination: string, isnewTab?: boolean) {
    if (isnewTab) {
      return destination;
    }
    let href: string = document.getElementsByTagName('base')[0].href;
    if (!href.endsWith('/')) {
      href += '/';
    }
    return destination;
  }
}